// import React, { useState, useEffect, useContext } from "react";
// import AuthContext from "../../context/AuthContext";
// import { API_URL } from "../../components/api";
// import Select from "react-select";
// import { useHistory } from "react-router-dom";
// import Axios from "axios";
// import {
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
// } from "@mui/material";
// import "./order.css";

// function OrderForm() {
//   const { user } = useContext(AuthContext);
//   let authTokens = JSON.parse(localStorage.getItem("authTokens"));

//   const [isAddProductModalOpen, setAddProductModalOpen] = useState(false);
//   const [isAddServiceModalOpen, setAddServiceModalOpen] = useState(false);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [selectedService, setSelectedService] = useState(null);

//   const [productQuantity, setProductQuantity] = useState(1);
//   const [serviceQuantity, setServiceQuantity] = useState(1);

//   const [addedProducts, setAddedProducts] = useState([]);
//   const [Clients, setClients] = useState([]);
//   const [client, setClient] = useState("");

//   const [Products, setProducts] = useState([]);
//   const [Services, setServices] = useState([]);

//   const [addedServices, setAddedServices] = useState([]);

//   const [selectedDate, setSelectedDate] = useState(getDefaultDate());
//   const [newSubscription, setNewSubscription] = useState(false);
//   const [message, setMessage] = useState(null);
//   const [confirmNewSubscriptionOpen, setConfirmNewSubscriptionOpen] = useState(false);
//   const [confirmNewSubscription, setConfirmNewSubscription] = useState(false);
//   const [isFree, setIsFree] = useState(false);
//   const [isOffersModalOpen, setOffersModalOpen] = useState(false);
//   const [username, setUsername] = useState(null);
//   const [usernames, setUsernames] = useState([]);

//   const [dialogOpen, setDialogOpen] = useState(false);
//   const [credentials, setCredentials] = useState({
//     username: "",
//     password: "",
//   });

//   const [sites, setSites] = useState([]);
//   const [cores, setCores] = useState([]);
//   const [wirelessAccessPoints, setWirelessAccessPoints] = useState([]);

//   const [selectedSite, setSelectedSite] = useState(null);
//   const [selectedCore, setSelectedCore] = useState(null);
//   const [selectedWirelessAccessPoint, setSelectedWirelessAccessPoint] = useState(null);

//   const [openPrice, setOpenPrice] = useState(0);

//   const [cpeMacAddress, setCpeMacAddress] = useState("");
//   const [cpeError, setCpeError] = useState("");

//   const [consumptionOption, setConsumptionOption] = useState("");
//   const [isConsumptionLocked, setIsConsumptionLocked] = useState(false);

//   const [hasCopied, setHasCopied] = useState(false);

//   // --- IDM states ---
//   const [subscriptionType, setSubscriptionType] = useState("OSS");
//   const [idmPlans, setIdmPlans] = useState([]);
//   const [selectedIdmPlan, setSelectedIdmPlan] = useState(null);

//   const history = useHistory();
//   console.log(selectedCore);

//   const validate = () => {
//     const hasWireless = hasWirelessService();
//     const hasFiber = hasFiberService();

//     if (
//       client === "" ||
//       (addedServices.length === 0 && addedProducts.length === 0)
//     ) {
//       return false;
//     }

//     if (newSubscription) {
//       if (subscriptionType === "OSS") {
//         if (hasFiber && !selectedCore) return false;
//         if (hasWireless && (!selectedSite || !selectedWirelessAccessPoint || !cpeMacAddress || !isValidMacAddress(cpeMacAddress)))
//           return false;
//       } else if (subscriptionType === "IDM") {
//         if (!selectedIdmPlan) return false;
//       }
//     }

//     return true;
//   };

//   useEffect(() => {
//     let isMounted = true;

//     const getProducts = async () => {
//       try {
//         const response = await Axios.get(`${API_URL}/inventory/products/`, {
//           headers: {
//             Authorization: `Bearer ${authTokens.access}`,
//             "Content-Type": "application/json",
//           },
//           params: {
//             username: user.username,
//           },
//         });
//         if (response.status === 200 && isMounted) {
//           setProducts(response.data);
//         }
//       } catch (error) {
//         console.error(error);
//       }
//     };

//     const getClients = async () => {
//       try {
//         const response = await Axios.get(`${API_URL}/administration/clients/`, {
//           headers: {
//             Authorization: `Bearer ${authTokens.access}`,
//             "Content-Type": "application/json",
//           },
//           params: {
//             username: user.username,
//           },
//         });
//         if (response.status === 200 && isMounted) {
//           setClients(response.data);
//         }
//       } catch (error) {
//         console.error(error);
//       }
//     };

//     const getServices = async () => {
//       try {
//         const response = await Axios.get(`${API_URL}/inventory/services/`, {
//           headers: {
//             Authorization: `Bearer ${authTokens.access}`,
//             "Content-Type": "application/json",
//           },
//           params: {
//             username: user.username,
//           },
//         });
//         if (response.status === 200 && isMounted) {
//           setServices(response.data);
//         }
//       } catch (error) {
//         console.error(error);
//       }
//     };

//     getProducts();
//     getClients();
//     getServices();

//     // Fetch IDM plans
//     const fetchIdmPlans = async () => {
//       try {
//         const res = await Axios.get(`${API_URL}/radius/plans/idm/`, {
//           headers: { Authorization: `Bearer ${authTokens.access}` },
//         });
//         const options = res.data.map((plan) => ({
//           label: plan.plan_name,
//           value: plan.internet_plan_id,
//         }));
//         setIdmPlans(options);
//       } catch (err) {
//         console.error("Error fetching IDM plans:", err);
//       }
//     };
//     fetchIdmPlans();

//     const fetchSites = async () => {
//       try {
//         const response = await Axios.get(`${API_URL}/radius/sites/`, {
//           headers: { Authorization: `Bearer ${authTokens.access}` },
//           params: { username: user.username },
//         });
//         if (response.status === 200) {
//           const options = response.data.map((item) => ({
//             label: item.site_name,
//             value: item.site_id,
//           }));
//           setSites(options);
//         }
//       } catch (error) {
//         console.error("Error fetching sites:", error);
//       }
//     };
//     fetchSites();

//     const fetchCores = async () => {
//       try {
//         const response = await Axios.get(`${API_URL}/radius/fiber/cores/select/`, {
//           headers: { Authorization: `Bearer ${authTokens.access}` },
//           params: { username: user.username },
//         });
//         if (response.status === 200) {
//           const options = response.data.map((item) => ({
//             label: item.code,
//             value: item.core_id,
//           }));
//           setCores(options);
//         }
//       } catch (error) {
//         console.error("Error fetching cores:", error);
//       }
//     };
//     fetchCores();

//     return () => {
//       isMounted = false;
//     };
//   }, [authTokens.access, user.username]);

//   const clientOptions = Clients
//     ? Clients.map((item) => ({
//         label: item.fullname_en,
//         value: item.client_id,
//       }))
//     : [];

//   const productOptions = Products.map((item) => ({
//     label: item.name,
//     value: item.product_id,
//     selling_price: item.selling_price,
//   }));
//   const serviceOptions = Services.map((item) => ({
//     label: item.name,
//     value: item.service_id,
//     selling_price: item.selling_price,
//   }));

//   function getDefaultDate() {
//     const today = new Date();
//     const year = today.getFullYear();
//     const month = String(today.getMonth() + 1).padStart(2, "0");
//     const day = String(today.getDate()).padStart(2, "0");
//     return `${year}-${month}-${day}`;
//   }

//   const handleAddProductClick = () => {
//     setAddProductModalOpen(true);
//   };

//   const handleAddServiceClick = () => {
//     setAddServiceModalOpen(true);
//   };

//   const handleAddProductModalClose = () => {
//     setAddProductModalOpen(false);
//     setProductQuantity(1);
//   };

//   const handleAddServiceModalClose = () => {
//     setAddServiceModalOpen(false);
//     setServiceQuantity(1);
//   };

//   const customFilter = (option, inputValue) => {
//     const words = inputValue.toLowerCase().split(" ");
//     return words.every((word) => option.label.toLowerCase().includes(word));
//   };
//   const handleClientChange = (selectedOption) => {
//     setClient(selectedOption);
//     const filteredUsernames = Clients.filter(
//       (item) => item.client_id === selectedOption.value,
//     ).map((item) => ({
//       label: item.username,
//       value: item.subscription_id,
//     }));
//     setUsernames(filteredUsernames);
//     setUsername(null);
//   };

//   const handleDeleteProduct = (index) => {
//     const updatedProducts = [...addedProducts];
//     updatedProducts.splice(index, 1);
//     setAddedProducts(updatedProducts);
//   };

//   const handleDeleteService = (index) => {
//     const updatedServices = [...addedServices];
//     updatedServices.splice(index, 1);
//     setAddedServices(updatedServices);
//   };

//   const handleAddProduct = () => {
//     if (!selectedProduct || !selectedProduct.value) {
//       console.warn("No product selected");
//       return;
//     }

//     const newProduct = {
//       id: selectedProduct.value,
//       name: selectedProduct.label,
//       quantity: productQuantity,
//       selling_price: isFree ? 0 : selectedProduct.selling_price,
//       total_price: isFree
//         ? 0
//         : Number(selectedProduct.selling_price || 0) * Number(productQuantity || 0),
//       is_free: isFree,
//     };
//     setAddedProducts([...addedProducts, newProduct]);
//     handleAddProductModalClose();
//     setIsFree(false);
//   };

//   const handleAddService = () => {
//     if (!selectedService || !selectedService.label) {
//       console.warn("No service selected");
//       return;
//     }

//     const openPriceServices = [
//       "Maintenance Fee",
//       "Electrical Accessories",
//       "Fiber Installation",
//       "Labor Fees",
//       "IT Support",
//       "Fiber Cable",
//     ];

//     const isOpenPrice = openPriceServices.includes(selectedService.label);

//     const newService = {
//       id: selectedService.value,
//       name: selectedService.label,
//       quantity: isOpenPrice ? 1 : serviceQuantity,
//       selling_price: isOpenPrice
//         ? openPrice
//         : isFree
//           ? 0
//           : selectedService.selling_price,
//       total_price: isOpenPrice
//         ? Number(openPrice || 0)
//         : isFree
//           ? 0
//           : Number(selectedService.selling_price || 0) * Number(serviceQuantity || 0),
//       is_free: isFree,
//       consumption_option: consumptionOption ? consumptionOption.toUpperCase() : null,
//     };

//     const specialServiceNames = [
//       "Basic",
//       "Light",
//       "Popular",
//       "Premium",
//       "Gold",
//       "Platinum",
//       "Diamond",
//     ];

//     const isSpecialService = specialServiceNames.some((serviceName) =>
//       newService.name.toLowerCase().includes(serviceName.toLowerCase()),
//     );

//     if (isSpecialService) {
//       setConfirmNewSubscriptionOpen(true);
//     }

//     setAddedServices([...addedServices, newService]);
//     handleAddServiceModalClose();
//     setIsFree(false);
//     setOpenPrice(0);
//   };

//   const handleConfirmNewSubscription = () => {
//     setNewSubscription(true);
//     handleAddServiceModalClose();
//     setConfirmNewSubscriptionOpen(false);
//   };
//   const handleCancelNewSubscription = () => {
//     setNewSubscription(false);
//     handleAddServiceModalClose();
//     setConfirmNewSubscriptionOpen(false);
//   };

//   const showMessage = (message, type = "success") => {
//     setMessage({ text: message, type });
//     const timeout = type === "danger" ? 5000 : 3000;
//     setTimeout(() => {
//       setMessage(null);
//     }, timeout);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       console.log("Submitting Order. New Subscription Mode:", newSubscription);
//       const payload = {
//         Action: "Post",
//         products: addedProducts,
//         services: addedServices,
//         client: client,
//         date: selectedDate,
//         productquantity: productQuantity,
//         servicequantity: serviceQuantity,
//         userdealer: user.username,
//         newSubscription: newSubscription,
//         site: selectedSite?.value || null,
//         wireless_access_point: selectedWirelessAccessPoint?.value || null,
//         core: selectedCore?.value || null,
//         cpe_mac_address: cpeMacAddress || null,
//       };

//       // IDM specific fields
//       if (newSubscription && subscriptionType === "IDM") {
//         payload.subscription_type = "IDM";
//         payload.idm_plan_id = selectedIdmPlan?.value;
//       }

//       const response = await Axios.post(`${API_URL}/inventory/order/new/`, payload, {
//         headers: {
//           Authorization: `Bearer ${authTokens.access}`,
//         },
//       });

//       console.log("Backend Response:", response.data);

//       if (response.data.username && response.data.password) {
//         const { username, password } = response.data;
//         setCredentials({ username, password });
//         setHasCopied(false);
//         setConfirmNewSubscription(true);
//         setDialogOpen(true);
//         showMessage("Order successful! Subscription created.", "success");
//       } else {
//         if (newSubscription) {
//           console.warn("Expected credentials but got none. Check backend logic.");
//           showMessage(
//             "Order created, but NO credentials were returned. Please check the order list.",
//             "warning",
//           );
//         } else {
//           showMessage(response.data.message || "Order successful!", "success");
//           setTimeout(() => {
//             history.push("/accounting/order");
//           }, 2000);
//         }
//       }
//     } catch (error) {
//       console.error("Order submission error:", error);
//       const errorMessage = error.response?.data?.error || "Order failed! Please try again.";
//       showMessage(errorMessage, "danger");
//     }
//   };

//   const offers = {
//     offer1: {
//       products: [
//         { name: "SXT sq New", quantity: 1 },
//         { name: "Cudy 1200", quantity: 1 },
//         { name: "Indoor Cat6 Cable", quantity: 35 },
//       ],
//     },
//     offer2: {
//       products: [
//         { name: "LDF New", quantity: 1 },
//         { name: "Cudy 1200", quantity: 1 },
//         { name: "Indoor Cat6 Cable", quantity: 35 },
//       ],
//     },
//     offer3: {
//       products: [
//         { name: "LHG New", quantity: 1 },
//         { name: "Cudy 1200", quantity: 1 },
//         { name: "Indoor Cat6 Cable", quantity: 35 },
//       ],
//     },
//     offer4: {
//       products: [
//         { name: "SXT sq Used", quantity: 1 },
//         { name: "Cudy 1200", quantity: 1 },
//         { name: "Indoor Cat6 Cable", quantity: 35 },
//       ],
//     },
//     offer5: {
//       products: [
//         { name: "LDF Used", quantity: 1 },
//         { name: "Cudy 1200", quantity: 1 },
//         { name: "Indoor Cat6 Cable", quantity: 35 },
//       ],
//     },
//   };

//   const handleOpenOffersModal = () => {
//     setOffersModalOpen(true);
//   };

//   const handleCloseOffersModal = () => {
//     setOffersModalOpen(false);
//   };
//   const handleOfferClick = (offerKey) => {
//     const offer = offers[offerKey];
//     const allProducts = Products;
//     const offerProducts = offer.products.map((product) => {
//       const matchedProduct = allProducts.find((p) => p.name === product.name);
//       if (!matchedProduct) {
//         console.warn("Offer product not found in catalog:", product.name);
//         return null;
//       }
//       return {
//         id: matchedProduct.product_id,
//         name: product.name,
//         quantity: product.quantity,
//         selling_price: isFree ? 0 : matchedProduct.selling_price,
//         total_price: isFree
//           ? 0
//           : Number(matchedProduct.selling_price || 0) * Number(product.quantity || 0),
//         is_free: isFree,
//       };
//     }).filter(p => p);
//     setAddedProducts((prevAddedProducts) => [...prevAddedProducts, ...offerProducts]);
//     setIsFree(false);
//   };

//   const isValidMacAddress = (value) => {
//     const macRegex = /^([0-9A-F]{2}:){5}[0-9A-F]{2}$/;
//     return macRegex.test(value);
//   };

//   useEffect(() => {
//     setCpeError(
//       cpeMacAddress && !isValidMacAddress(cpeMacAddress)
//         ? "Invalid CPE MAC Address format"
//         : "",
//     );
//   }, [cpeMacAddress]);

//   const renderOffersTable = () => (
//     <TableContainer component={Paper}>
//       <Table>
//         <TableHead>
//           <TableRow>
//             <TableCell>Offer</TableCell>
//             <TableCell>Product Name</TableCell>
//             <TableCell>Quantity</TableCell>
//           </TableRow>
//         </TableHead>
//         <TableBody>
//           {Object.entries(offers).map(([offerKey, offer], index) =>
//             offer.products.map((product, productIndex) => (
//               <TableRow
//                 key={`${index}-${productIndex}`}
//                 onClick={() => handleOfferClick(offerKey)}
//                 style={{ cursor: "pointer" }}
//               >
//                 {productIndex === 0 && (
//                   <TableCell rowSpan={offer.products.length}>{offerKey}</TableCell>
//                 )}
//                 <TableCell>{product.name}</TableCell>
//                 <TableCell>{product.quantity}</TableCell>
//               </TableRow>
//             )),
//           )}
//         </TableBody>
//       </Table>
//     </TableContainer>
//   );

//   const fetchWirelessAccessPoints = async (siteName) => {
//     try {
//       const response = await Axios.get(`${API_URL}/radius/wirelessAccessPoint/`, {
//         headers: { Authorization: `Bearer ${authTokens.access}` },
//         params: { username: user.username, site: siteName },
//       });
//       if (response.status === 200) {
//         const options = response.data.map((item) => ({
//           label: item.name,
//           value: item.ap_id,
//         }));
//         setWirelessAccessPoints(options);
//       }
//     } catch (error) {
//       console.error("Error fetching wireless access points:", error);
//     }
//   };

//   const hasWirelessService = () => {
//     return addedServices.some(
//       (service) =>
//         service &&
//         service.name &&
//         service.name.toLowerCase().startsWith("wireless"),
//     );
//   };

//   const hasFiberService = () => {
//     return addedServices.some(
//       (service) =>
//         service &&
//         service.name &&
//         service.name.toLowerCase().startsWith("fiber"),
//     );
//   };

//   const handleSiteChange = (selectedOption) => {
//     setSelectedSite(selectedOption);
//     if (selectedOption) {
//       fetchWirelessAccessPoints(selectedOption.label);
//     }
//   };

//   return (
//     <div className="order">
//       <div className="order-header">
//         <div className="form-group">
//           <label>
//             Select Client:
//             <Select
//               className="search-line"
//               placeholder="Choose Client"
//               options={clientOptions}
//               onChange={handleClientChange}
//               filterOption={customFilter}
//               isSearchable={true}
//             />
//           </label>
//         </div>
//         <div>
//           <label htmlFor="order-date">Order Date:</label>
//           <input
//             type="date"
//             id="order-date"
//             value={selectedDate}
//             onChange={(e) => setSelectedDate(e.target.value)}
//             style={{ color: "aliceblue" }}
//           />
//         </div>
//       </div>

//       <div className="form-group">
//         <label>
//           New Subscription:
//           <input
//             type="checkbox"
//             checked={newSubscription}
//             onChange={(e) => setNewSubscription(e.target.checked)}
//           />
//         </label>
//       </div>

//       {newSubscription && (
//         <div className="form-group">
//           <label>Subscription Type:</label>
//           <Select
//             className="search-line"
//             placeholder="Choose Type"
//             options={[
//               { value: "OSS", label: "OSS (Fiber/Wireless)" },
//               { value: "IDM", label: "IDM (HSIPRO)" },
//             ]}
//             onChange={(opt) => setSubscriptionType(opt.value)}
//             value={{ value: subscriptionType, label: subscriptionType === "OSS" ? "OSS (Fiber/Wireless)" : "IDM (HSIPRO)" }}
//           />
//         </div>
//       )}

//       {newSubscription && subscriptionType === "IDM" && (
//         <div className="form-group">
//           <label>IDM Plan:</label>
//           <Select
//             className="search-line"
//             placeholder="Choose IDM Plan"
//             options={idmPlans}
//             onChange={(opt) => setSelectedIdmPlan(opt)}
//           />
//         </div>
//       )}

//       <div className="order-body">
//         <div className="table-container-products">
//           <TableContainer component={Paper}>
//             <Table>
//               <TableHead>
//                 <TableRow>
//                   <TableCell>Product Name</TableCell>
//                   <TableCell>Quantity</TableCell>
//                   <TableCell>Selling Price</TableCell>
//                   <TableCell>Total Price</TableCell>
//                   <TableCell>Is Free</TableCell>
//                   <TableCell>Action</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {addedProducts.map((product, index) => (
//                   <TableRow key={index}>
//                     <TableCell>{product.name}</TableCell>
//                     <TableCell>{product.quantity}</TableCell>
//                     <TableCell>{product.selling_price}</TableCell>
//                     <TableCell>{product.total_price}</TableCell>
//                     <TableCell>{product.is_free ? "Yes" : "No"}</TableCell>
//                     <TableCell>
//                       <Button variant="outlined" color="secondary" onClick={() => handleDeleteProduct(index)}>
//                         Delete
//                       </Button>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//           <Button variant="contained" onClick={handleAddProductClick} className="buttonWithMargin">
//             Add Product
//           </Button>
//         </div>

//         <div className="table-container-services">
//           <TableContainer component={Paper}>
//             <Table>
//               <TableHead>
//                 <TableRow>
//                   <TableCell>Service Name</TableCell>
//                   <TableCell>Quantity</TableCell>
//                   <TableCell>Selling Price</TableCell>
//                   <TableCell>Total Price</TableCell>
//                   <TableCell>Is Free</TableCell>
//                   <TableCell>Consumption</TableCell>
//                   <TableCell>Action</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {addedServices.map((service, index) => (
//                   <TableRow key={index}>
//                     <TableCell>{service.name}</TableCell>
//                     <TableCell>{service.quantity}</TableCell>
//                     <TableCell>{service.selling_price}</TableCell>
//                     <TableCell>{service.total_price}</TableCell>
//                     <TableCell>{service.is_free ? "Yes" : "No"}</TableCell>
//                     <TableCell>
//                       {service.consumption_option
//                         ? service.consumption_option.charAt(0) + service.consumption_option.slice(1).toLowerCase()
//                         : "-"}
//                     </TableCell>
//                     <TableCell>
//                       <Button variant="outlined" color="secondary" onClick={() => handleDeleteService(index)}>
//                         Delete
//                       </Button>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//           <Button variant="contained" onClick={handleAddServiceClick} className="buttonWithMargin">
//             Add Service
//           </Button>
//         </div>
//       </div>

//       {/* All Dialogs remain exactly as they were in the original code */}
//       <Dialog
//         open={isAddProductModalOpen}
//         onClose={handleAddProductModalClose}
//         PaperProps={{ style: { width: "500px", height: "80vh" } }}
//       >
//         <DialogTitle>Add Product</DialogTitle>
//         <DialogContent className="modal-content">
//           <div className="form-group">
//             <label>
//               Select Product:
//               <Select
//                 className="search-line"
//                 placeholder="Choose Product"
//                 options={productOptions}
//                 onChange={(opt) => setSelectedProduct(opt)}
//               />
//             </label>
//           </div>
//           <label>
//             Quantity:
//             <input
//               className="form-control"
//               type="text"
//               value={productQuantity}
//               required
//               onChange={(e) => setProductQuantity(Number(e.target.value) || 0)}
//             />
//           </label>
//           <label>
//             Is Free:
//             <input type="checkbox" checked={isFree} onChange={(e) => setIsFree(e.target.checked)} />
//           </label>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleAddProductModalClose}>Cancel</Button>
//           <Button onClick={handleAddProduct} variant="contained" color="primary">
//             Add
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Dialog open={confirmNewSubscriptionOpen} onClose={() => setConfirmNewSubscriptionOpen(false)}>
//         <DialogTitle>New Subscription</DialogTitle>
//         <DialogContent>
//           <p>Would you like to create a new subscription for this service?</p>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCancelNewSubscription}>No</Button>
//           <Button onClick={handleConfirmNewSubscription} color="primary">
//             Yes
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Dialog
//         open={isAddServiceModalOpen}
//         onClose={handleAddServiceModalClose}
//         PaperProps={{ style: { width: "500px", height: "80vh" } }}
//       >
//         <DialogTitle>Add Service</DialogTitle>
//         <DialogContent className="modal-content">
//           <div className="form-group">
//             <label>
//               Select Service:
//               <Select
//                 className="search-line"
//                 placeholder="Choose Service"
//                 options={serviceOptions}
//                 onChange={(opt) => {
//                   if (!opt) {
//                     setSelectedService(null);
//                     setConsumptionOption("");
//                     setIsConsumptionLocked(false);
//                     return;
//                   }
//                   setSelectedService(opt);
//                   const openPriceServices = [
//                     "Maintenance Fee",
//                     "Electrical Accessories",
//                     "Fiber Installation",
//                     "Labor Fees",
//                     "IT Support",
//                     "Fiber Cable",
//                   ];
//                   if (openPriceServices.includes(opt.label)) {
//                     setServiceQuantity(1);
//                   }
//                   const limitedTypes = ["Basic", "Light", "Popular"];
//                   const unlimitedTypes = ["Premium", "Gold", "Platinum", "Diamond"];
//                   const lower = opt.label.toLowerCase();
//                   if (limitedTypes.some((name) => lower.includes(name.toLowerCase()))) {
//                     setConsumptionOption("LIMITED");
//                     setIsConsumptionLocked(false);
//                   } else if (unlimitedTypes.some((name) => lower.includes(name.toLowerCase()))) {
//                     setConsumptionOption("UNLIMITED");
//                     setIsConsumptionLocked(true);
//                   } else {
//                     setConsumptionOption("");
//                     setIsConsumptionLocked(false);
//                   }
//                 }}
//               />
//             </label>
//           </div>
//           {[
//             "Maintenance Fee",
//             "Electrical Accessories",
//             "Fiber Installation",
//             "Labor Fees",
//             "IT Support",
//             "Fiber Cable",
//           ].includes(selectedService?.label) ? (
//             <label>
//               Price:
//               <input
//                 className="form-control"
//                 type="number"
//                 value={openPrice}
//                 required
//                 onChange={(e) => {
//                   const value = parseFloat(e.target.value);
//                   setOpenPrice(value >= 0 ? value : 0);
//                 }}
//                 min={0}
//                 step={0.01}
//               />
//             </label>
//           ) : (
//             <label>
//               Quantity:
//               <input
//                 className="form-control"
//                 type="text"
//                 value={serviceQuantity}
//                 required
//                 onChange={(e) => setServiceQuantity(Number(e.target.value) || 0)}
//               />
//             </label>
//           )}
//           <label>
//             Is Free:
//             <input type="checkbox" checked={isFree} onChange={(e) => setIsFree(e.target.checked)} />
//           </label>
//           {selectedService?.label &&
//             ["basic", "light", "popular", "premium", "gold", "platinum", "diamond"].some((type) =>
//               selectedService.label.toLowerCase().includes(type),
//             ) && (
//               <div className="form-group">
//                 <label>
//                   Consumption Option:
//                   <select
//                     className="form-control"
//                     value={consumptionOption}
//                     disabled={isConsumptionLocked}
//                     onChange={(e) => setConsumptionOption(e.target.value)}
//                   >
//                     <option value="">Select...</option>
//                     <option value="LIMITED">Limited</option>
//                     <option value="UNLIMITED">Unlimited</option>
//                   </select>
//                 </label>
//               </div>
//             )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleAddServiceModalClose}>Cancel</Button>
//           <Button onClick={handleAddService} variant="contained" color="primary">
//             Add
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Button variant="contained" color="primary" onClick={handleOpenOffersModal} style={{ marginBottom: "20px" }}>
//         View Offers
//       </Button>

//       <Dialog open={isOffersModalOpen} onClose={handleCloseOffersModal}>
//         <DialogTitle>Available Offers</DialogTitle>
//         <DialogContent>{renderOffersTable()}</DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseOffersModal}>Close</Button>
//         </DialogActions>
//       </Dialog>

//       {confirmNewSubscription && (
//         <Dialog
//           open={confirmNewSubscription}
//           onClose={(event, reason) => {
//             if (reason !== "backdropClick" && reason !== "escapeKeyDown" && hasCopied) {
//               setConfirmNewSubscription(false);
//               history.push("/accounting/order");
//             }
//           }}
//           disableEscapeKeyDown
//         >
//           <DialogTitle>Subscription Created Successfully</DialogTitle>
//           <DialogContent>
//             <div
//               style={{
//                 marginBottom: "15px",
//                 padding: "10px",
//                 backgroundColor: "#f5f5f5",
//                 borderRadius: "4px",
//               }}
//             >
//               <p><strong>Username:</strong> {credentials.username}</p>
//               <p><strong>Password:</strong> {credentials.password}</p>
//             </div>
//             {!hasCopied ? (
//               <p style={{ fontSize: "0.9em", color: "#d32f2f", fontWeight: "bold" }}>
//                 ⚠️ You must copy these credentials before you can continue.
//               </p>
//             ) : (
//               <p style={{ fontSize: "0.9em", color: "#2e7d32", fontWeight: "bold" }}>
//                 ✅ Credentials copied! You may now close this window.
//               </p>
//             )}
//           </DialogContent>
//           <DialogActions>
//             <Button
//               onClick={() => {
//                 if (navigator.clipboard && navigator.clipboard.writeText) {
//                   navigator.clipboard.writeText(`Username: ${credentials.username}\nPassword: ${credentials.password}`);
//                   setHasCopied(true);
//                   showMessage("Credentials copied to clipboard!", "success");
//                 } else {
//                   alert("Clipboard API not available. Please copy manually or use HTTPS.");
//                   setHasCopied(true);
//                 }
//               }}
//               color="secondary"
//               variant="outlined"
//             >
//               Copy Credentials
//             </Button>
//             <Button
//               onClick={() => {
//                 setConfirmNewSubscription(false);
//                 history.push("/accounting/order");
//               }}
//               color="primary"
//               variant="contained"
//               disabled={!hasCopied}
//             >
//               Close & Finish
//             </Button>
//           </DialogActions>
//         </Dialog>
//       )}

//       <Button variant="contained" onClick={handleSubmit} className="submit" disabled={!validate()}>
//         Submit
//       </Button>

//       {newSubscription && hasWirelessService() && (
//         <div className="form-group">
//           <label>
//             Select Site:
//             <Select
//               className="search-line"
//               placeholder="Choose Site"
//               options={sites}
//               onChange={handleSiteChange}
//               value={selectedSite}
//             />
//           </label>
//         </div>
//       )}

//       {newSubscription && hasWirelessService() && selectedSite && (
//         <div className="form-group">
//           <label>
//             Select Wireless Access Point:
//             <Select
//               className="search-line"
//               placeholder="Choose Wireless Access Point"
//               options={wirelessAccessPoints}
//               onChange={(opt) => setSelectedWirelessAccessPoint(opt)}
//               value={selectedWirelessAccessPoint}
//             />
//           </label>
//           <label>
//             CPE MAC Address:
//             <input
//               type="text"
//               className={`form-control ${cpeError ? "is-invalid" : ""}`}
//               style={{ width: "250px" }}
//               value={cpeMacAddress}
//               onChange={(e) => {
//                 const raw = e.target.value;
//                 const rawNoCols = raw.replace(/:/g, "");
//                 const cleaned = rawNoCols.replace(/[^0-9A-Fa-f]/g, "");
//                 setCpeError(cleaned.length !== rawNoCols.length);
//                 let formatted = "";
//                 for (let i = 0; i < cleaned.length && i < 12; i += 2) {
//                   if (i > 0) formatted += ":";
//                   formatted += cleaned.substring(i, i + 2).toUpperCase();
//                 }
//                 setCpeMacAddress(formatted);
//               }}
//               maxLength={17}
//               placeholder="Please enter a valid CPE MAC address"
//               required
//             />
//           </label>
//           {cpeError && (
//             <div className="invalid-feedback" style={{ display: "block", fontSize: "0.85rem" }}>
//               Only hexadecimal digits (0–9, A–F) are allowed.
//             </div>
//           )}
//         </div>
//       )}

//       {newSubscription && hasFiberService() && (
//         <div className="form-group">
//           <label>
//             Select Core:
//             <Select
//               className="search-line"
//               placeholder="Choose Core"
//               options={cores}
//               onChange={(opt) => setSelectedCore(opt)}
//               value={selectedCore}
//             />
//           </label>
//         </div>
//       )}

//       {message && (
//         <div
//           className={`alert alert-${message.type} alert-dismissible fade show`}
//           role="alert"
//           style={{
//             position: "fixed",
//             bottom: "10px",
//             margin: "10px",
//             right: "10px",
//             zIndex: "9999",
//           }}
//         >
//           {message.text}
//         </div>
//       )}
//     </div>
//   );
// }

// export default OrderForm;



import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../context/AuthContext";
import LanguageContext from "../../context/LanguageContext";
import { API_URL } from "../../components/api";
import Select from "react-select";
import { useHistory } from "react-router-dom";
import Axios from "axios";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import "./order.css";

function OrderForm() {
  const { language, t } = useContext(LanguageContext);
  const { user } = useContext(AuthContext);
  let authTokens = JSON.parse(localStorage.getItem("authTokens"));

  // --- Existing states ---
  const [isAddProductModalOpen, setAddProductModalOpen] = useState(false);
  const [isAddServiceModalOpen, setAddServiceModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedService, setSelectedService] = useState(null);

  const [productQuantity, setProductQuantity] = useState(1);
  const [serviceQuantity, setServiceQuantity] = useState(1);

  const [addedProducts, setAddedProducts] = useState([]);
  const [Clients, setClients] = useState([]);
  const [client, setClient] = useState("");

  const [Products, setProducts] = useState([]);
  const [Services, setServices] = useState([]);

  const [addedServices, setAddedServices] = useState([]);

  const [selectedDate, setSelectedDate] = useState(getDefaultDate());
  const [newSubscription, setNewSubscription] = useState(false);
  const [message, setMessage] = useState(null);
  const [confirmNewSubscriptionOpen, setConfirmNewSubscriptionOpen] = useState(false);
  const [confirmNewSubscription, setConfirmNewSubscription] = useState(false);
  const [isFree, setIsFree] = useState(false);
  const [isOffersModalOpen, setOffersModalOpen] = useState(false);
  const [username, setUsername] = useState(null);
  const [usernames, setUsernames] = useState([]);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
  });

  const [sites, setSites] = useState([]);
  const [cores, setCores] = useState([]);
  const [wirelessAccessPoints, setWirelessAccessPoints] = useState([]);

  const [selectedSite, setSelectedSite] = useState(null);
  const [selectedCore, setSelectedCore] = useState(null);
  const [accountHolders, setAccountHolders] = useState([]);
  const [selectedAccountHolder, setSelectedAccountHolder] = useState(null);
  const [orderWarehouses, setOrderWarehouses] = useState([]);
  const [warehouseRestricted, setWarehouseRestricted] = useState(false);
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [warehouseStock, setWarehouseStock] = useState([]);
  const [selectedWirelessAccessPoint, setSelectedWirelessAccessPoint] = useState(null);

  const [openPrice, setOpenPrice] = useState(0);

  const [cpeMacAddress, setCpeMacAddress] = useState("");
  const [cpeError, setCpeError] = useState("");

  const [consumptionOption, setConsumptionOption] = useState("");
  const [isConsumptionLocked, setIsConsumptionLocked] = useState(false);

  const [hasCopied, setHasCopied] = useState(false);

  // --- New states for IDM inside Add Service modal ---
  const [serviceType, setServiceType] = useState("OSS"); // "OSS" or "IDM"
  const [idmPlans, setIdmPlans] = useState([]);
  const [idmUsername, setIdmUsername] = useState("");
  const [idmPassword, setIdmPassword] = useState("");
  const [selectedIdmPlan, setSelectedIdmPlan] = useState(null);

  useEffect(() => {
    let isMounted = true;
    Axios.get(`${API_URL}/inventory/warehouses/`, {
      headers: { Authorization: `Bearer ${authTokens.access}`, "Content-Type": "application/json" },
      params: { username: user.username, type: "order_scope" },
    })
      .then((response) => {
        if (!isMounted || response.status !== 200) return;
        const warehouses = response.data.warehouses || [];
        setOrderWarehouses(warehouses);
        setWarehouseRestricted(!!response.data.restricted);
        if (response.data.restricted && warehouses.length === 1)
          setSelectedWarehouse({ value: warehouses[0].warehouse_id, label: warehouses[0].warehouse_name });
      })
      .catch((error) => console.error(error));
    return () => { isMounted = false; };
  }, []);

  useEffect(() => {
    let isMounted = true;
    setWarehouseStock([]);
    if (selectedWarehouse) {
      Axios.get(`${API_URL}/inventory/warehouses/products/`, {
        headers: { Authorization: `Bearer ${authTokens.access}`, "Content-Type": "application/json" },
        params: { username: user.username, warehouse_id: selectedWarehouse.value },
      })
        .then((response) => {
          if (isMounted && response.status === 200) setWarehouseStock(response.data);
        })
        .catch((error) => console.error(error));
    }
    return () => { isMounted = false; };
  }, [selectedWarehouse]);

  const history = useHistory();

  // --- Validation function (updated to handle IDM service) ---
  const validate = () => {
    const hasWireless = hasWirelessService();
    const hasFiber = hasFiberService();
    const hasIdmService = addedServices.some(s => s.isIDM === true);

    if (!selectedAccountHolder) return false;
    if (addedProducts.length > 0 && !selectedWarehouse) return false;
    if (client === "" || (addedServices.length === 0 && addedProducts.length === 0)) {
      return false;
    }

    // If we have an IDM service, we don't need OSS validation
    if (hasIdmService) {
      return true;
    }

    // Otherwise OSS validation
    if (newSubscription) {
      if (hasFiber && !selectedCore) return false;
      if (hasWireless && (!selectedSite || !selectedWirelessAccessPoint || !cpeMacAddress || !isValidMacAddress(cpeMacAddress)))
        return false;
    }
    return true;
  };

  // --- Fetch data on mount ---
  useEffect(() => {
    let isMounted = true;

    const getAccountHolders = async () => {
      try {
        const response = await Axios.get(`${API_URL}/inventory/warehouses/`, {
          headers: { Authorization: `Bearer ${authTokens.access}`, "Content-Type": "application/json" },
          params: { username: user.username, type: "account_holders" },
        });
        if (response.status === 200 && isMounted)
          setAccountHolders(response.data.filter((h) => h.holder_type === "company" && h.dealer_id));
      } catch (error) { console.error(error); }
    };
    const getProducts = async () => {
      try {
        const response = await Axios.get(`${API_URL}/inventory/products/`, {
          headers: { Authorization: `Bearer ${authTokens.access}`, "Content-Type": "application/json" },
          params: { username: user.username },
        });
        if (response.status === 200 && isMounted)
          setProducts(response.data.filter((p) => p.is_active !== 0 && p.is_active !== false));
      } catch (error) { console.error(error); }
    };

    const getClients = async () => {
      try {
        // ARABIC_ORDER_CLIENT_DISPLAY_ONLY
        if (language === "ar") {
          const response = await Axios.get(`${API_URL}/administration/clients/`, {
            headers: { Authorization: `Bearer ${authTokens.access}`, "Content-Type": "application/json" },
            params: { username: user.username, lang: "ar" },
          });
          if (response.status === 200 && isMounted) setClients(response.data);
          return;
        }

        const response = await Axios.get(`${API_URL}/administration/clients/`, {
          headers: { Authorization: `Bearer ${authTokens.access}`, "Content-Type": "application/json" },
          params: { username: user.username },
        });
        if (response.status === 200 && isMounted) setClients(response.data);
      } catch (error) { console.error(error); }
    };

    const getServices = async () => {
      try {
        const response = await Axios.get(`${API_URL}/inventory/services/`, {
          headers: { Authorization: `Bearer ${authTokens.access}`, "Content-Type": "application/json" },
          params: { username: user.username },
        });
        if (response.status === 200 && isMounted)
          setServices(response.data.filter((s) => s.is_active !== 0 && s.is_active !== false));
      } catch (error) { console.error(error); }
    };

    getAccountHolders();
    getProducts();
    getClients();
    getServices();

    // Fetch IDM plans
    const fetchIdmPlans = async () => {
      try {
        const res = await Axios.get(`${API_URL}/radius/plans/idm/`, {
          headers: { Authorization: `Bearer ${authTokens.access}` },
        });
        const options = res.data.map((plan) => ({
          label: plan.plan_name,
          value: plan.internet_plan_id,
        }));
        setIdmPlans(options);
      } catch (err) {
        console.error("Error fetching IDM plans:", err);
      }
    };
    fetchIdmPlans();

    const fetchSites = async () => {
      try {
        const response = await Axios.get(`${API_URL}/radius/sites/`, {
          headers: { Authorization: `Bearer ${authTokens.access}` },
          params: { username: user.username },
        });
        if (response.status === 200) {
          const options = response.data.map((item) => ({ label: item.site_name, value: item.site_id }));
          setSites(options);
        }
      } catch (error) { console.error(error); }
    };
    fetchSites();

    const fetchCores = async () => {
      try {
        const response = await Axios.get(`${API_URL}/radius/fiber/cores/select/`, {
          headers: { Authorization: `Bearer ${authTokens.access}` },
          params: { username: user.username },
        });
        if (response.status === 200) {
          const options = response.data.map((item) => ({ label: item.code, value: item.core_id }));
          setCores(options);
        }
      } catch (error) { console.error(error); }
    };
    fetchCores();

    return () => { isMounted = false; };
  }, [authTokens.access, user.username]);

  useEffect(() => {
    if (language !== "ar") {
      return undefined;
    }

    let mounted = true;

    const getArabicClients = async () => {
      try {
        const response = await Axios.get(`${API_URL}/administration/clients/`, {
          headers: { Authorization: `Bearer ${authTokens.access}`, "Content-Type": "application/json" },
          params: { username: user.username, lang: "ar" },
        });

        if (response.status === 200 && mounted) {
          setClients(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    getArabicClients();

    return () => {
      mounted = false;
    };
  }, [language, authTokens.access, user.username]);

  // --- Helper functions (unchanged) ---
  const clientOptions = Clients ? Clients.map(item => ({ label: item.fullname_en, value: item.client_id })) : [];

  const getArabicClientDisplayName = (option) => {
    const optionValue =
      option && option.value !== undefined
        ? option.value
        : option?.data?.value;

    const englishLabel =
      option?.label ||
      option?.data?.label ||
      "";

    const item = Clients.find(
      (row) => row.client_id === optionValue
    );

    const arabicName =
      item && typeof item.fullname_ar === "string"
        ? item.fullname_ar.trim()
        : "";

    return arabicName || englishLabel;
  };

  const arabicClientFilter = (option, inputValue) => {
    const words = inputValue
      .toLowerCase()
      .split(" ")
      .filter(Boolean);

    const displayName =
      getArabicClientDisplayName(option).toLowerCase();

    return words.every((word) =>
      displayName.includes(word)
    );
  };
  const warehouseStockById = new Map(warehouseStock.map((row) => [Number(row.product_id), Number(row.quantity)]));
  const productOptions = Products.filter(item => warehouseStockById.has(Number(item.product_id))).map(item => ({ label: item.name, value: item.product_id, selling_price: item.selling_price, stock: warehouseStockById.get(Number(item.product_id)), isDisabled: warehouseStockById.get(Number(item.product_id)) <= 0 }));
  const selectedProductStock = selectedProduct ? warehouseStockById.get(Number(selectedProduct.value)) : undefined;
  const selectedProductAdded = addedProducts.filter(p => selectedProduct && Number(p.id) === Number(selectedProduct.value)).reduce((sum, p) => sum + Number(p.quantity || 0), 0);
  const productAddBlocked = selectedProductStock === undefined || Number(productQuantity || 0) < 1 || Number(productQuantity || 0) + selectedProductAdded > selectedProductStock;
  const handleWarehouseChange = (opt) => {
    setSelectedWarehouse(opt);
    setSelectedProduct(null);
    setAddedProducts([]);
  };
  const serviceOptions = Services.map(item => ({ label: item.name, value: item.service_id, selling_price: item.selling_price }));

  function getDefaultDate() {
    const today = new Date();
    return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
  }

  const handleAddProductClick = () => setAddProductModalOpen(true);
  const handleAddServiceClick = () => setAddServiceModalOpen(true);
  const handleAddProductModalClose = () => { setAddProductModalOpen(false); setProductQuantity(1); };
  const handleAddServiceModalClose = () => {
    setAddServiceModalOpen(false);
    setServiceQuantity(1);
    setServiceType("OSS");
    setIdmUsername("");
    setIdmPassword("");
    setSelectedIdmPlan(null);
  };
  const customFilter = (option, inputValue) => inputValue.toLowerCase().split(" ").every(word => option.label.toLowerCase().includes(word));

  const handleClientChange = (selectedOption) => {
    setClient(selectedOption);
    const filteredUsernames = Clients.filter(item => item.client_id === selectedOption.value).map(item => ({ label: item.username, value: item.subscription_id }));
    setUsernames(filteredUsernames);
    setUsername(null);
  };

  const handleDeleteProduct = (index) => setAddedProducts(addedProducts.filter((_, i) => i !== index));
  const handleDeleteService = (index) => setAddedServices(addedServices.filter((_, i) => i !== index));

  const handleAddProduct = () => {
    if (!selectedProduct || !selectedProduct.value) return;
    const newProduct = {
      id: selectedProduct.value,
      name: selectedProduct.label,
      quantity: productQuantity,
      selling_price: isFree ? 0 : selectedProduct.selling_price,
      total_price: isFree ? 0 : Number(selectedProduct.selling_price || 0) * Number(productQuantity || 0),
      is_free: isFree,
    };
    setAddedProducts([...addedProducts, newProduct]);
    handleAddProductModalClose();
    setIsFree(false);
  };

  // --- Modified handleAddService to support IDM ---
  const handleAddService = () => {
    if (!selectedService || !selectedService.label) {
      console.warn("No service selected");
      return;
    }

    if (serviceType === "IDM") {
      // Validate IDM fields
      if (!idmUsername || !idmPassword || !selectedIdmPlan) {
        showMessage(language === "ar" ? t("orderForm.idmRequired") : "Please fill in IDM Username, Password, and Plan", "danger");
        return;
      }

      const newService = {
        id: selectedService.value,
        name: selectedService.label,
        isIDM: true,
        idmUsername,
        idmPassword,
        idmPlanId: selectedIdmPlan.value,
        idmPlanName: selectedIdmPlan.label,
        quantity: 1,
        selling_price: isFree ? 0 : selectedService.selling_price,
        total_price: isFree ? 0 : (selectedService.selling_price || 0),
        is_free: isFree,
      };
      setAddedServices([...addedServices, newService]);
      handleAddServiceModalClose();
      // Ensure newSubscription is set to true for IDM (will be handled in submit)
      setNewSubscription(true);
      // Reset IDM fields
      setIdmUsername("");
      setIdmPassword("");
      setSelectedIdmPlan(null);
      setIsFree(false);
    } else {
      // === OSS logic (existing) ===
      const openPriceServices = ["Maintenance Fee", "Electrical Accessories", "Fiber Installation", "Labor Fees", "IT Support", "Fiber Cable"];
      const isOpenPrice = openPriceServices.includes(selectedService.label);
      const newService = {
        id: selectedService.value,
        name: selectedService.label,
        quantity: isOpenPrice ? 1 : serviceQuantity,
        selling_price: isOpenPrice ? openPrice : (isFree ? 0 : selectedService.selling_price),
        total_price: isOpenPrice ? Number(openPrice || 0) : (isFree ? 0 : Number(selectedService.selling_price || 0) * Number(serviceQuantity || 0)),
        is_free: isFree,
        consumption_option: consumptionOption ? consumptionOption.toUpperCase() : null,
      };
      const specialServiceNames = ["Basic", "Light", "Popular", "Premium", "Gold", "Platinum", "Diamond"];
      const isSpecialService = specialServiceNames.some(name => newService.name.toLowerCase().includes(name.toLowerCase()));
      if (isSpecialService) setConfirmNewSubscriptionOpen(true);
      setAddedServices([...addedServices, newService]);
      handleAddServiceModalClose();
      setIsFree(false);
      setOpenPrice(0);
    }
  };

  const handleConfirmNewSubscription = () => {
    setNewSubscription(true);
    handleAddServiceModalClose();
    setConfirmNewSubscriptionOpen(false);
  };
  const handleCancelNewSubscription = () => {
    setNewSubscription(false);
    handleAddServiceModalClose();
    setConfirmNewSubscriptionOpen(false);
  };

  const showMessage = (text, type = "success") => {
    setMessage({ text, type });
    setTimeout(() => setMessage(null), type === "danger" ? 5000 : 3000);
  };

  // --- Modified handleSubmit to send IDM data when an IDM service exists ---
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    try {
      // Check if any service is IDM
      const idmService = addedServices.find(s => s.isIDM === true);
      const payload = {
        Action: "Post",
        products: addedProducts,
        services: addedServices,
        client: client,
        date: selectedDate,
        productquantity: productQuantity,
        servicequantity: serviceQuantity,
        userdealer: user.username,
        newSubscription: newSubscription || !!idmService, // force true if IDM service exists
        site: selectedSite?.value || null,
        wireless_access_point: selectedWirelessAccessPoint?.value || null,
        core: selectedCore?.value || null,
        cpe_mac_address: cpeMacAddress || null,
        accountHolder: selectedAccountHolder?.value || null,
        warehouse: selectedWarehouse?.value || null,
      };

      if (idmService) {
        payload.type = "IDM";
        payload.idm_username = idmService.idmUsername;
        payload.idm_password = idmService.idmPassword;
        payload.idm_plan_name = idmService.idmPlanName;
        payload.idm_plan_id = idmService.idmPlanId;
      }

      const response = await Axios.post(`${API_URL}/inventory/order/new/`, payload, {
        headers: { Authorization: `Bearer ${authTokens.access}` },
      });

      if (response.data.username && response.data.password) {
        setCredentials({ username: response.data.username, password: response.data.password });
        setHasCopied(false);
        setConfirmNewSubscription(true);
        setDialogOpen(true);
        showMessage(language === "ar" ? t("orderForm.orderSubscriptionSuccess") : "Order successful! Subscription created.", "success");
      } else {
        if (newSubscription || idmService) {
          console.warn("Expected credentials but got none.");
          showMessage(language === "ar" ? t("orderForm.orderNoCredentials") : "Order created, but NO credentials were returned. Please check the order list.", "warning");
        } else {
          showMessage(response.data.message || (language === "ar" ? t("orderForm.orderSuccess") : "Order successful!"), "success");
          setTimeout(() => history.push("/accounting/order"), 2000);
        }
      }
    } catch (error) {
      setSubmitting(false);
      console.error(error);
      const errorMessage = error.response?.data?.error || (language === "ar" ? t("orderForm.orderFailed") : "Order failed! Please try again.");
      showMessage(errorMessage, "danger");
    }
  };

  // --- Offers logic (unchanged) ---
  const offers = {
    offer1: { products: [{ name: "SXT sq New", quantity: 1 }, { name: "Cudy 1200", quantity: 1 }, { name: "Indoor Cat6 Cable", quantity: 35 }] },
    offer2: { products: [{ name: "LDF New", quantity: 1 }, { name: "Cudy 1200", quantity: 1 }, { name: "Indoor Cat6 Cable", quantity: 35 }] },
    offer3: { products: [{ name: "LHG New", quantity: 1 }, { name: "Cudy 1200", quantity: 1 }, { name: "Indoor Cat6 Cable", quantity: 35 }] },
    offer4: { products: [{ name: "SXT sq Used", quantity: 1 }, { name: "Cudy 1200", quantity: 1 }, { name: "Indoor Cat6 Cable", quantity: 35 }] },
    offer5: { products: [{ name: "LDF Used", quantity: 1 }, { name: "Cudy 1200", quantity: 1 }, { name: "Indoor Cat6 Cable", quantity: 35 }] },
  };
  const handleOpenOffersModal = () => setOffersModalOpen(true);
  const handleCloseOffersModal = () => setOffersModalOpen(false);
  const handleOfferClick = (offerKey) => {
    const offer = offers[offerKey];
    const allProducts = Products.filter(p => warehouseStockById.has(Number(p.product_id)));
    const offerProducts = offer.products.map(product => {
      const matched = allProducts.find(p => p.name === product.name);
      if (!matched) return null;
      return {
        id: matched.product_id,
        name: product.name,
        quantity: product.quantity,
        selling_price: isFree ? 0 : matched.selling_price,
        total_price: isFree ? 0 : Number(matched.selling_price) * product.quantity,
        is_free: isFree,
      };
    }).filter(p => p);
    setAddedProducts(prev => [...prev, ...offerProducts]);
    setIsFree(false);
  };
  const renderOffersTable = () => (
    <TableContainer component={Paper}>
      <Table>
        <TableHead><TableRow><TableCell>{language === "ar" ? t("orderForm.offer") : "Offer"}</TableCell><TableCell>{language === "ar" ? t("orderForm.productName") : "Product Name"}</TableCell><TableCell>{language === "ar" ? t("orderForm.quantity") : "Quantity"}</TableCell></TableRow></TableHead>
        <TableBody>
          {Object.entries(offers).map(([key, offer], idx) => offer.products.map((product, pidx) => (
            <TableRow key={`${idx}-${pidx}`} onClick={() => handleOfferClick(key)} style={{ cursor: "pointer" }}>
              {pidx === 0 && (
              <TableCell rowSpan={offer.products.length}>
                {language === "ar"
                  ? `${t("orderForm.offer")} ${idx + 1}`
                  : key}
              </TableCell>
            )}
              <TableCell>{product.name}</TableCell>
              <TableCell>{product.quantity}</TableCell>
            </TableRow>
          )))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  // --- Helper functions for OSS ---
  const isValidMacAddress = (value) => /^([0-9A-F]{2}:){5}[0-9A-F]{2}$/.test(value);
  useEffect(() => {
    setCpeError(cpeMacAddress && !isValidMacAddress(cpeMacAddress) ? "Invalid CPE MAC Address format" : "");
  }, [cpeMacAddress]);

  const fetchWirelessAccessPoints = async (siteName) => {
    try {
      const response = await Axios.get(`${API_URL}/radius/wirelessAccessPoint/`, {
        headers: { Authorization: `Bearer ${authTokens.access}` },
        params: { username: user.username, site: siteName },
      });
      if (response.status === 200) {
        const options = response.data.map(item => ({ label: item.name, value: item.ap_id }));
        setWirelessAccessPoints(options);
      }
    } catch (error) { console.error(error); }
  };
  const hasWirelessService = () => addedServices.some(s => s.name && s.name.toLowerCase().startsWith("wireless"));
  const hasFiberService = () => addedServices.some(s => s.name && s.name.toLowerCase().startsWith("fiber"));
  const handleSiteChange = (selectedOption) => {
    setSelectedSite(selectedOption);
    if (selectedOption) fetchWirelessAccessPoints(selectedOption.label);
  };


  const displayConsumptionOption = (value) => {
    if (!value) {
      return "-";
    }

    if (language === "ar") {
      if (value === "LIMITED") {
        return t("orderForm.limited");
      }

      if (value === "UNLIMITED") {
        return t("orderForm.unlimited");
      }
    }

    return (
      value.charAt(0)
      + value.slice(1).toLowerCase()
    );
  };

  // --- Render ---
  return (
    <div className="order">
      <div className="order-header">
        <div className="form-group">
          <label>{language === "ar" ? t("payments.accountHolder") + ":" : "Select Account Holder:"}</label>
          <Select
            className="search-line"
            placeholder={language === "ar" ? t("payments.chooseAccountHolder") : "Choose Account Holder"}
            options={accountHolders.map((h) => ({ value: h.account_holder_id, label: language === "ar" ? (h.name_ar || h.name_en) : (h.name_en || h.name_ar) }))}
            onChange={(opt) => setSelectedAccountHolder(opt)}
            value={selectedAccountHolder}
            isSearchable={false}
          />
        </div>
        <div className="form-group">
          <label>{language === "ar" ? t("payments.warehouse") + ":" : "Select Warehouse:"}</label>
          <Select
            className="search-line"
            placeholder={language === "ar" ? t("payments.chooseWarehouse") : "Choose Warehouse"}
            options={orderWarehouses.map((w) => ({ value: w.warehouse_id, label: w.warehouse_name }))}
            onChange={handleWarehouseChange}
            value={selectedWarehouse}
            isClearable={!warehouseRestricted}
            isDisabled={warehouseRestricted && orderWarehouses.length === 1}
            isSearchable={false}
          />
        </div>
        <div className="form-group">
          <label>{language === "ar" ? t("orderForm.selectClient") : "Select Client:"}</label>
          <Select
            className="search-line"
            placeholder={language === "ar" ? t("orderForm.chooseClient") : "Choose Client"}
            options={clientOptions}
            onChange={handleClientChange}
            filterOption={
              language === "ar"
                ? arabicClientFilter
                : customFilter
            }
            formatOptionLabel={(option) =>
              language === "ar"
                ? getArabicClientDisplayName(option)
                : option.label
            }
            isSearchable
          />
        </div>
        <div>
          <label htmlFor="order-date">{language === "ar" ? t("orderForm.orderDate") : "Order Date:"}</label>
          <input type="date" id="order-date" className="order-form-date" value={selectedDate} onChange={e => setSelectedDate(e.target.value)} />
        </div>
      </div>

      <div className="form-group">
        <label>{language === "ar" ? t("orderForm.newSubscriptionLabel") : "New Subscription:"} <input type="checkbox" checked={newSubscription} onChange={e => setNewSubscription(e.target.checked)} /></label>
      </div>

      <div className="order-body">
        {/* Products table */}
        <div className="table-container-products">
          <TableContainer component={Paper}>
            <Table>
              <TableHead><TableRow><TableCell>{language === "ar" ? t("orderForm.productName") : "Product Name"}</TableCell><TableCell>{language === "ar" ? t("orderForm.quantity") : "Quantity"}</TableCell><TableCell>{language === "ar" ? t("orderForm.sellingPrice") : "Selling Price"}</TableCell><TableCell>{language === "ar" ? t("orderForm.totalPrice") : "Total Price"}</TableCell><TableCell>{language === "ar" ? t("orderForm.isFree") : "Is Free"}</TableCell><TableCell>{language === "ar" ? t("orderForm.action") : "Action"}</TableCell></TableRow></TableHead>
              <TableBody>
                {addedProducts.map((p, idx) => (
                  <TableRow key={idx}>
                    <TableCell>{p.name}</TableCell><TableCell>{p.quantity}</TableCell><TableCell>{p.selling_price}</TableCell><TableCell>{p.total_price}</TableCell><TableCell>{p.is_free ? (language === "ar" ? t("orderForm.yes") : "Yes") : (language === "ar" ? t("orderForm.no") : "No")}</TableCell>
                    <TableCell><Button variant="outlined" color="secondary" onClick={() => handleDeleteProduct(idx)}>{language === "ar" ? t("orderForm.delete") : "Delete"}</Button></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Button variant="contained" onClick={handleAddProductClick} disabled={!selectedWarehouse} className="buttonWithMargin">{language === "ar" ? t("orderForm.addProduct") : "Add Product"}</Button>
        </div>

        {/* Services table */}
        <div className="table-container-services">
          <TableContainer component={Paper}>
            <Table>
              <TableHead><TableRow><TableCell>{language === "ar" ? t("orderForm.serviceName") : "Service Name"}</TableCell><TableCell>{language === "ar" ? t("orderForm.quantity") : "Quantity"}</TableCell><TableCell>{language === "ar" ? t("orderForm.sellingPrice") : "Selling Price"}</TableCell><TableCell>{language === "ar" ? t("orderForm.totalPrice") : "Total Price"}</TableCell><TableCell>{language === "ar" ? t("orderForm.isFree") : "Is Free"}</TableCell><TableCell>{language === "ar" ? t("orderForm.consumption") : "Consumption"}</TableCell><TableCell>{language === "ar" ? t("orderForm.action") : "Action"}</TableCell></TableRow></TableHead>
              <TableBody>
                {addedServices.map((s, idx) => (
                  <TableRow key={idx}>
                    <TableCell>{s.name}</TableCell><TableCell>{s.quantity}</TableCell><TableCell>{s.selling_price}</TableCell><TableCell>{s.total_price}</TableCell><TableCell>{s.is_free ? (language === "ar" ? t("orderForm.yes") : "Yes") : (language === "ar" ? t("orderForm.no") : "No")}</TableCell>
                    <TableCell>{displayConsumptionOption(s.consumption_option)}</TableCell>
                    <TableCell><Button variant="outlined" color="secondary" onClick={() => handleDeleteService(idx)}>{language === "ar" ? t("orderForm.delete") : "Delete"}</Button></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Button variant="contained" onClick={handleAddServiceClick} className="buttonWithMargin">{language === "ar" ? t("orderForm.addService") : "Add Service"}</Button>
        </div>
      </div>

      {/* Add Product Dialog (unchanged) */}
      <Dialog open={isAddProductModalOpen} onClose={handleAddProductModalClose} PaperProps={{ style: { width: "500px", maxWidth: "100%", maxHeight: "80vh" } }}>
        <DialogTitle>{language === "ar" ? t("orderForm.addProduct") : "Add Product"}</DialogTitle>
        <DialogContent className="modal-content">
          <div className="form-group"><label>{language === "ar" ? t("orderForm.selectProduct") : "Select Product:"}</label><Select
              classNamePrefix="order-item-select"
              placeholder={
                language === "ar"
                  ? t("orderForm.selectOption")
                  : undefined
              }
              options={productOptions}
              formatOptionLabel={(opt) => `${opt.label} (${opt.stock})`}
              onChange={opt => setSelectedProduct(opt)}
            /></div>
          <label>{language === "ar" ? t("orderForm.quantityLabel") : "Quantity:"} <input className="form-control" type="number" value={productQuantity} onChange={e => setProductQuantity(Number(e.target.value) || 0)} /></label>
          <label>{language === "ar" ? t("orderForm.isFreeLabel") : "Is Free:"} <input type="checkbox" checked={isFree} onChange={e => setIsFree(e.target.checked)} /></label>
        </DialogContent>
        <DialogActions><Button onClick={handleAddProductModalClose}>{language === "ar" ? t("orderForm.cancel") : "Cancel"}</Button><Button onClick={handleAddProduct} variant="contained" color="primary" disabled={productAddBlocked}>{language === "ar" ? t("orderForm.add") : "Add"}</Button></DialogActions>
      </Dialog>

      {/* New Subscription Confirmation Dialog (unchanged) */}
      <Dialog open={confirmNewSubscriptionOpen} onClose={() => setConfirmNewSubscriptionOpen(false)}>
        <DialogTitle>{language === "ar" ? t("orderForm.newSubscription") : "New Subscription"}</DialogTitle>
        <DialogContent><p>{language === "ar" ? t("orderForm.newSubscriptionQuestion") : "Would you like to create a new subscription for this service?"}</p></DialogContent>
        <DialogActions><Button onClick={handleCancelNewSubscription}>{language === "ar" ? t("orderForm.no") : "No"}</Button><Button onClick={handleConfirmNewSubscription} color="primary">{language === "ar" ? t("orderForm.yes") : "Yes"}</Button></DialogActions>
      </Dialog>

      {/* Add Service Dialog - MODIFIED to include IDM fields */}
      <Dialog open={isAddServiceModalOpen} onClose={handleAddServiceModalClose} PaperProps={{ style: { width: "500px", maxWidth: "100%", maxHeight: "80vh" } }}>
        <DialogTitle>{language === "ar" ? t("orderForm.addService") : "Add Service"}</DialogTitle>
        <DialogContent className="modal-content">
          <div className="form-group">
            <label>{language === "ar" ? t("orderForm.selectService") : "Select Service:"}</label>
            <Select
              classNamePrefix="order-item-select"
              placeholder={
                language === "ar"
                  ? t("orderForm.selectOption")
                  : undefined
              }
              options={serviceOptions}
              onChange={(opt) => {
                if (!opt) { setSelectedService(null); setConsumptionOption(""); setIsConsumptionLocked(false); setServiceType("OSS"); return; }
                setSelectedService(opt);
                setServiceType("OSS"); // default to OSS when service changes
                setIdmUsername(""); setIdmPassword(""); setSelectedIdmPlan(null);
                const openPriceServices = ["Maintenance Fee", "Electrical Accessories", "Fiber Installation", "Labor Fees", "IT Support", "Fiber Cable"];
                if (openPriceServices.includes(opt.label)) setServiceQuantity(1);
                const limitedTypes = ["Basic", "Light", "Popular"];
                const unlimitedTypes = ["Premium", "Gold", "Platinum", "Diamond"];
                const lower = opt.label.toLowerCase();
                if (limitedTypes.some(name => lower.includes(name.toLowerCase()))) {
                  setConsumptionOption("LIMITED"); setIsConsumptionLocked(false);
                } else if (unlimitedTypes.some(name => lower.includes(name.toLowerCase()))) {
                  setConsumptionOption("UNLIMITED"); setIsConsumptionLocked(true);
                } else {
                  setConsumptionOption(""); setIsConsumptionLocked(false);
                }
              }}
            />
          </div>

          {/* Type selector: OSS or IDM */}
          <div className="form-group">
            <label>{language === "ar" ? t("orderForm.serviceType") : "Service Type:"}</label>
            <Select
              classNamePrefix="order-item-select"
              options={[{ value: "OSS", label: "OSS (Fiber/Wireless)" }, { value: "IDM", label: "IDM (HSIPRO)" }]}
              formatOptionLabel={(option) =>
                language === "ar"
                  ? (
                    option.value === "OSS"
                      ? t("orderForm.ossServiceType")
                      : t("orderForm.idmServiceType")
                  )
                  : option.label
              }
              onChange={opt => setServiceType(opt.value)}
              value={{ value: serviceType, label: serviceType === "OSS" ? "OSS (Fiber/Wireless)" : "IDM (HSIPRO)" }}
            />
          </div>

          {serviceType === "OSS" ? (
            <>
              {["Maintenance Fee", "Electrical Accessories", "Fiber Installation", "Labor Fees", "IT Support", "Fiber Cable"].includes(selectedService?.label) ? (
                <label>{language === "ar" ? t("orderForm.priceLabel") : "Price:"} <input className="form-control" type="number" value={openPrice} onChange={e => setOpenPrice(parseFloat(e.target.value) || 0)} min={0} step={0.01} /></label>
              ) : (
                <label>{language === "ar" ? t("orderForm.quantityLabel") : "Quantity:"} <input className="form-control" type="number" value={serviceQuantity} onChange={e => setServiceQuantity(Number(e.target.value) || 0)} min={1} /></label>
              )}
              <label>{language === "ar" ? t("orderForm.isFreeLabel") : "Is Free:"} <input type="checkbox" checked={isFree} onChange={e => setIsFree(e.target.checked)} /></label>
              {selectedService?.label && ["basic","light","popular","premium","gold","platinum","diamond"].some(t => selectedService.label.toLowerCase().includes(t)) && (
                <div className="form-group">
                  <label>{language === "ar" ? t("orderForm.consumptionOption") : "Consumption Option:"}
                    <select className="form-control" value={consumptionOption} disabled={isConsumptionLocked} onChange={e => setConsumptionOption(e.target.value)}>
                      <option value="">
                        {language === "ar"
                          ? t("orderForm.selectOption")
                          : "Select..."}
                      </option>
                      <option value="LIMITED">
                        {language === "ar"
                          ? t("orderForm.limited")
                          : "Limited"}
                      </option>
                      <option value="UNLIMITED">
                        {language === "ar"
                          ? t("orderForm.unlimited")
                          : "Unlimited"}
                      </option>
                    </select>
                  </label>
                </div>
              )}
            </>
          ) : (
            <>
              <div className="form-group"><label>{language === "ar" ? t("orderForm.idmUsername") : "IDM Username:"}</label><input type="text" className="form-control" value={idmUsername} onChange={e => setIdmUsername(e.target.value)} required /></div>
              <div className="form-group"><label>{language === "ar" ? t("orderForm.idmPassword") : "IDM Password:"}</label><input type="password" className="form-control" value={idmPassword} onChange={e => setIdmPassword(e.target.value)} required /></div>
              <div className="form-group"><label>{language === "ar" ? t("orderForm.idmPlan") : "IDM Plan:"}</label><Select classNamePrefix="order-item-select" options={idmPlans} onChange={opt => setSelectedIdmPlan(opt)} placeholder={language === "ar" ? t("orderForm.chooseIdmPlan") : "Choose IDM Plan"} /></div>
              <label>{language === "ar" ? t("orderForm.isFreeLabel") : "Is Free:"} <input type="checkbox" checked={isFree} onChange={e => setIsFree(e.target.checked)} /></label>
            </>
          )}
        </DialogContent>
        <DialogActions><Button onClick={handleAddServiceModalClose}>{language === "ar" ? t("orderForm.cancel") : "Cancel"}</Button><Button onClick={handleAddService} variant="contained" color="primary">{language === "ar" ? t("orderForm.add") : "Add"}</Button></DialogActions>
      </Dialog>

      <Button variant="contained" color="primary" onClick={handleOpenOffersModal} disabled={!selectedWarehouse} style={{ marginBottom: "20px" }}>{language === "ar" ? t("orderForm.viewOffers") : "View Offers"}</Button>
      <Dialog open={isOffersModalOpen} onClose={handleCloseOffersModal}><DialogTitle>{language === "ar" ? t("orderForm.availableOffers") : "Available Offers"}</DialogTitle><DialogContent>{renderOffersTable()}</DialogContent><DialogActions><Button onClick={handleCloseOffersModal}>{language === "ar" ? t("orderForm.close") : "Close"}</Button></DialogActions></Dialog>

      {confirmNewSubscription && (
        <Dialog open={confirmNewSubscription} onClose={(event, reason) => { if (reason !== "backdropClick" && reason !== "escapeKeyDown" && hasCopied) { setConfirmNewSubscription(false); history.push("/accounting/order"); } }} disableEscapeKeyDown>
          <DialogTitle>{language === "ar" ? t("orderForm.subscriptionCreated") : "Subscription Created Successfully"}</DialogTitle>
          <DialogContent>
            <div style={{ marginBottom: "15px", padding: "10px", backgroundColor: "#f5f5f5", color: "#122632", borderRadius: "4px" }}>
              <p><strong>{language === "ar" ? t("orderForm.username") : "Username:"}</strong> {credentials.username}</p><p><strong>{language === "ar" ? t("orderForm.password") : "Password:"}</strong> {credentials.password}</p>
            </div>
            {!hasCopied ? <p style={{ fontSize: "0.9em", color: "#d32f2f", fontWeight: "bold" }}>{language === "ar" ? t("orderForm.copyRequired") : "⚠️ You must copy these credentials before you can continue."}</p> : <p style={{ fontSize: "0.9em", color: "#2e7d32", fontWeight: "bold" }}>{language === "ar" ? t("orderForm.copyDone") : "✅ Credentials copied! You may now close this window."}</p>}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => { if (navigator.clipboard) { navigator.clipboard.writeText(`Username: ${credentials.username}\nPassword: ${credentials.password}`); setHasCopied(true); showMessage(language === "ar" ? t("orderForm.credentialsCopied") : "Credentials copied to clipboard!", "success"); } else { alert(language === "ar" ? t("orderForm.clipboardUnavailable") : "Clipboard API not available."); setHasCopied(true); } }} color="secondary" variant="outlined">{language === "ar" ? t("orderForm.copyCredentials") : "Copy Credentials"}</Button>
            <Button onClick={() => { setConfirmNewSubscription(false); history.push("/accounting/order"); }} color="primary" variant="contained" disabled={!hasCopied}>{language === "ar" ? t("orderForm.closeFinish") : "Close & Finish"}</Button>
          </DialogActions>
        </Dialog>
      )}

      <Button variant="contained" onClick={handleSubmit} className="submit" disabled={submitting || !validate()}>{submitting ? (language === "ar" ? t("orderForm.submitting") : "Submitting...") : (language === "ar" ? t("orderForm.submit") : "Submit")}</Button>

      {newSubscription && hasWirelessService() && (
        <div className="form-group"><label>{language === "ar" ? t("orderForm.selectSite") : "Select Site:"}</label><Select classNamePrefix="order-item-select" placeholder={language === "ar" ? t("orderForm.selectSite") : undefined} options={sites} onChange={handleSiteChange} value={selectedSite} /></div>
      )}
      {newSubscription && hasWirelessService() && selectedSite && (
        <div className="form-group">
          <label>{language === "ar" ? t("orderForm.selectWirelessAccessPoint") : "Select Wireless Access Point:"}</label><Select classNamePrefix="order-item-select" placeholder={language === "ar" ? t("orderForm.selectWirelessAccessPoint") : undefined} options={wirelessAccessPoints} onChange={opt => setSelectedWirelessAccessPoint(opt)} value={selectedWirelessAccessPoint} />
          <label>{language === "ar" ? t("orderForm.cpeMacAddress") : "CPE MAC Address:"}
            <input type="text" className={`form-control ${cpeError ? "is-invalid" : ""}`} style={{ width: "250px" }} value={cpeMacAddress} onChange={e => {
              const raw = e.target.value, rawNoCols = raw.replace(/:/g, ""), cleaned = rawNoCols.replace(/[^0-9A-Fa-f]/g, "");
              setCpeError(cleaned.length !== rawNoCols.length);
              let formatted = "";
              for (let i = 0; i < cleaned.length && i < 12; i += 2) { if (i > 0) formatted += ":"; formatted += cleaned.substring(i, i + 2).toUpperCase(); }
              setCpeMacAddress(formatted);
            }} maxLength={17} placeholder={language === "ar" ? t("orderForm.cpeMacPlaceholder") : "Please enter a valid CPE MAC address"} required />
          </label>
          {cpeError && <div className="invalid-feedback" style={{ display: "block", fontSize: "0.85rem" }}>{language === "ar" ? t("orderForm.hexOnly") : "Only hexadecimal digits (0–9, A–F) are allowed."}</div>}
        </div>
      )}
      {newSubscription && hasFiberService() && (
        <div className="form-group"><label>{language === "ar" ? t("orderForm.selectCore") : "Select Core:"}</label><Select classNamePrefix="order-item-select" placeholder={language === "ar" ? t("orderForm.selectCore") : undefined} options={cores} onChange={opt => setSelectedCore(opt)} value={selectedCore} /></div>
      )}

      {message && <div className={`alert alert-${message.type} alert-dismissible fade show`} role="alert" style={{ position: "fixed", bottom: "10px", margin: "10px", right: "10px", zIndex: "9999" }}>{message.text}</div>}
    </div>
  );
}

export default OrderForm;